module.exports = __webpack_public_path__ + "img/retired-2008-nangong.8a56bc33.jpg";